import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { subscriptionUserAPI } from "../../utilities/api";

interface SubscriptionUserState {
  activeUsers: any;
  fetchingActiveUsers: boolean;
  refreshRequired: boolean;
}

const initialState: SubscriptionUserState = {
  activeUsers: [],
  fetchingActiveUsers: false,
  refreshRequired: false,
}

const subscriptionUserSlice = createSlice({
  name: 'subscriptionUser',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getActiveSubscriptionUsers.pending, (state) => {
      state.fetchingActiveUsers = true;
    });
    builder.addCase(getActiveSubscriptionUsers.fulfilled, (state, action) => {
      state.fetchingActiveUsers = false;
      state.activeUsers = action.payload;
      state.refreshRequired = false;
    });
    builder.addCase(getActiveSubscriptionUsers.rejected, (state) => {
      state.fetchingActiveUsers = false;
    });
    builder.addCase(deactivateSubscriptionUser.fulfilled, (state) => {
      state.refreshRequired = true;
    });
  }
});

export const getActiveSubscriptionUsers = createAsyncThunk('stateSubscriptionUser/getActiveSubscriptionUsers', async () => {
  return await subscriptionUserAPI.getActiveUsers();
});

export const deactivateSubscriptionUser = createAsyncThunk('stateSubscriptionUser/deactivateSubscriptionUser', async (id: string) => {
  return await subscriptionUserAPI.deactivate(id);
});

export default subscriptionUserSlice.reducer;